import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  timeline: {
    head: [],
    body: []
  },
  isTimeLineLoader: true,
}
const reducer = (state = initialState, action) => {
  switch (action.type) {

    case types.SUCCESS_TIME_SHEET:

      var data = action.data.map(i => {
        return [{ isAvatar: true, name: i.employeeName, avatar: i.profileImage, loc: i.location, dep: i.department, bu: i.businessUnit, isTrakZoLite: i.trakzoLite,empCode:i.empCode }, i.team, i.date, i.checkIn, i.checkOut, i.loggedInHrs, i.activeHrs, i.prodHrs, i.unProdHrs, i.idleHrs, { location: i.location }, { businessUnit: i.businessUnit }, { department: i.department }, { id: i.userSessionId }]
      })
      return {
        ...state,
        timeline: {
          head: [
            {
              label: 'Employee Name',
              align: 'left',
              isFilter: true,
              filterVal: null,
              index: 0
            },
            {
              label: 'Team',
              align: 'left',
              isFilter: true,
              filterVal: null,
              index: 1
            },

            {
              label: 'Date',
              align: 'center',
            },
            {
              label: 'Check In',
              align: 'right'
            },
            {
              label: 'Check Out',
              align: 'right'
            },
            {
              label: 'Logged In Hrs',
              align: 'right'
            },
            {
              label: 'Active Hrs',
              align: 'right'
            },
            {
              label: 'Productive Hrs',
              align: 'right'
            },
            {
              label: 'Non-Core Hrs',
              align: 'right'
            },
            {
              label: 'Away Hrs',
              align: 'right'
            },
            {
              label: 'Location',
              align: 'left',
              filterVal: null,
              index: 10
            },
            {
              label: 'Business Unit',
              align: 'left',
              isFilter: true,
              filterVal: null,
              index: 11
            },
            {
              label: 'Department',
              align: 'left',
              isFilter: true,
              filterVal: null,
              index: 12
            },
          ],
          body: data
        },
        isTimeLineLoader: false
      }
    case types.FAILED_TIME_SHEET:

      return {
        ...state,
        isTimeLineLoader: false,
        head: [],
        body: []
      }
    case types.FETCH_TIME_SHEET:

      return {
        ...state,
        isTimeLineLoader: true,
        head: [],
        body: []
      }
    default:
      return state
  }
}
export default reducer